
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 32h8v8H0zM16 32h8v8h-8zM0 16h8v8H0zM16 16h8v8h-8zM32 16h8v8h-8zM0 0h8v8H0zM16 0h8v8h-8zM32 0h8v8h-8zM32 32h8v8h-8z"}})])
          )
        }
      }
    